export default {
  AUTO: 'auto',
  CUSTOM: 'custom',
};
